const AutoIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M5 17H3a1 1 0 01-1-1v-5l2.47-5.5A2 2 0 016.3 4h11.4a2 2 0 011.83 1.5L22 11v5a1 1 0 01-1 1h-2" />
    <circle cx="7.5" cy="17.5" r="2.5" />
    <circle cx="16.5" cy="17.5" r="2.5" />
  </svg>
);

const MotoIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="5.5" cy="17.5" r="3.5" />
    <circle cx="18.5" cy="17.5" r="3.5" />
    <path d="M15 6l-2 4H8.5L7 13.5M15 6h3l1.5 4H15M8.5 10L6 17.5M15 10l1.5 4" />
  </svg>
);

export default function MockBrowser({ type = "auto" }) {
  const isAuto = type === "auto";
  const cars = isAuto
    ? [{ n:"Fiat 500", p:"€29/g" }, { n:"Nissan Qashqai", p:"€55/g" }, { n:"BMW 3 Series", p:"€72/g" }, { n:"Mercedes GLE", p:"€110/g" }]
    : [{ n:"Vespa 125", p:"€22/g" }, { n:"Honda SH 350", p:"€28/g" }, { n:"BMW R1250GS", p:"€89/g" }, { n:"Yamaha MT-07", p:"€65/g" }];

  return (
    <div className="browser" style={{ position:"relative" }}>
      {/* Browser chrome */}
      <div className="bb">
        <div className="bd" style={{ background:"#FF5F56" }} />
        <div className="bd" style={{ background:"#FFBD2E" }} />
        <div className="bd" style={{ background:"#27C93F" }} />
        <div className="bu">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          tuonoleggio.noleggioincloud.app
        </div>
      </div>

      {/* Site topbar */}
      <div className="btb">
        <span className="blogo">{isAuto ? "GoldRent" : "MotoRent Rimini"}</span>
        <div style={{ display:"flex", gap:".4rem" }}>
          <span className="bbtn g">Accedi</span>
          <span className="bbtn">Prenota</span>
        </div>
      </div>

      {/* Hero area */}
      <div className="bha">
        <h4>{isAuto ? "Noleggia la tua auto" : "Noleggia la tua moto a Rimini"}</h4>
        <p>Disponibilità in tempo reale • Paga online in sicurezza</p>
        <div className="bsr">
          <span style={{ padding:"0 .55rem", fontSize:".7rem", fontFamily:"sans-serif" }}>▤</span>
          <input readOnly placeholder="Seleziona le date di noleggio..." />
          <span className="bsb">Cerca</span>
        </div>
      </div>

      {/* Vehicle cards */}
      <div className="bcars">
        {cars.map(c => (
          <div className="bcar" key={c.n}>
            <div className="bci">{isAuto ? <AutoIcon /> : <MotoIcon />}</div>
            <div className="bcn">{c.n}</div>
            <div className="bcp">{c.p}</div>
            <div className="bcb">Prenota →</div>
          </div>
        ))}
      </div>

      <div className="blive">LIVE</div>
    </div>
  );
}
